export const ROUTE_PATHS = {
	home: "/",
	gameAnalysis: "/game-analysis",
	customerManager: "/customer-manager",
	locationManager: "/location-manager",
	withdrawalManager: "/withdrawal-manager",
	logIn:"/login",
};
